import React, { Dispatch, FunctionComponent } from 'react'

import { Modal, ModalProps } from '@matillion/component-library'

import { Loading } from 'components/Loading/Loading'

import { ErrorContextWrapper } from './components/ErrorContextWrapper'
import classes from './ParameterOverlay.module.scss'

export interface ParameterOverlayProps extends Pick<ModalProps, 'size'> {
  isLoading: boolean
  setShowEditor: Dispatch<boolean>
}

export const ParameterOverlay: FunctionComponent<
  React.PropsWithChildren<ParameterOverlayProps>
> = ({ size = 'default', setShowEditor, isLoading, children }) => {
  return (
    <Modal
      className={classes.ParameterOverlay}
      size={size}
      onCancel={() => setShowEditor(false)}
      ariaLabelledBy="parameter-overlay-title"
      disableBackdropClick={true}
    >
      <ErrorContextWrapper>
        {isLoading && (
          <div className={classes.MultiOptionSelector__Loading}>
            <Loading />
          </div>
        )}
        {!isLoading && children}
      </ErrorContextWrapper>
    </Modal>
  )
}
